import {connect} from "react-redux";
import ModalComponent from "components/ModalComponent";
import React from "react";
import { faCopy } from '@fortawesome/pro-solid-svg-icons/faCopy';
import FontAwesome from "utils/FA";
import {Button} from 'react-bootstrap';
import './styles/embed_form_modal.scss';


const EmbedFormModal = connect()(({formType, link}) => (
  <ModalComponent title={"Embedded " + formType}>
    <div>
      <p>To embed the {formType} form directly into your website, copy the html below and have your IT team add it to your website where appropriate.</p>

      <div className='card bg-light'><code className='embed-form-code'>{link}</code></div>

      <div className='embed-form-button'>
        <Button onClick={() => navigator.clipboard.writeText(link)}>
          <FontAwesome className='embed-form-item' icon={faCopy}/>
          Copy To Clipboard
        </Button>
      </div>
    </div>
  </ModalComponent>
));

export default EmbedFormModal;
